import { render } from "./addBuyer.vue?vue&type=template&id=46af668d&scoped=true"
import script from "./addBuyer.vue?vue&type=script&lang=js"
export * from "./addBuyer.vue?vue&type=script&lang=js"

import "./addBuyer.vue?vue&type=style&index=0&id=46af668d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46af668d"]])

export default __exports__